/* ============================================================
   CUSTOM PDP V2 — JavaScript
   ------------------------------------------------------------
   Extracted from sections/custom-pdp-v2.liquid.
   Liquid-driven config (free shipping threshold, discount codes,
   bundle tiers, etc.) is injected via the inline <script> block
   in the section as window.PDP_CONFIG (and legacy window.BUNDLE_*
   aliases for backwards compatibility).

   Load order (in the section):
     1. Inline <script>  -> defines window.PDP_CONFIG + aliases
     2. This file        -> reads window.PDP_CONFIG and runs

   Three logical groups live in this file:
     A. Main PDP behavior  (tabs, accordions, cart drawer, compare drawer)
     B. Buy More & Save More tier buttons
     C. Robust tooltip (body-level, immune to ancestor overflow)
   ============================================================ */

/* ============================================================
   A. MAIN PDP BEHAVIOR
   ============================================================ */

// Tabs (desktop) and accordions (mobile)
function openTab(evt, tabId) {
  document.querySelectorAll('.tab-pane').forEach(pane => pane.classList.remove('active'));
  document.querySelectorAll('.tab-link').forEach(link => link.classList.remove('active'));
  document.querySelectorAll('.mobile-accordion-btn').forEach(btn => btn.classList.remove('active'));

  document.querySelectorAll(`#${tabId}`).forEach(tab => tab.classList.add('active'));
  if (evt && evt.currentTarget) {
    evt.currentTarget.classList.add('active');
  }
}

function toggleAccordion(tabId, el) {
  const isActive = el.classList.contains('active');
  document.querySelectorAll('.mobile-accordion-btn').forEach(btn => btn.classList.remove('active'));
  document.querySelectorAll('.tab-pane').forEach(pane => pane.classList.remove('active'));

  if (!isActive) {
    el.classList.add('active');
    document.querySelectorAll(`#${tabId}`).forEach(tab => tab.classList.add('active'));
  }
}

// Smooth scroll to the Loox reviews section
function scrollToReviews(event) {
  event.preventDefault();
  const reviewsSection = document.getElementById('looxReviews');
  if (reviewsSection) {
    // Account for sticky header height (~27px toolbar + header)
    const headerOffset = 90;
    const elementPosition = reviewsSection.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  } else {
    console.warn('Loox reviews section (#looxReviews) not found on this page.');
  }
}

// ==========================================
// CART LOGIC (AJAX DRAWER)
// ==========================================

// Single source of truth for the free shipping threshold (injected by Liquid).
const FREE_SHIPPING_THRESHOLD = (window.PDP_CONFIG && window.PDP_CONFIG.freeShippingThreshold) || 140;

const cartDrawer = document.getElementById('customCartDrawer');
const cartOverlay = document.getElementById('customCartOverlay');
const cartItemsList = document.getElementById('cartItemsList');
const cartSubtotal = document.getElementById('cartDrawerSubtotal');
const cartEmptyMsg = document.getElementById('cartEmptyMsg');
const shippingText = document.getElementById('shippingText');
const shippingProgress = document.getElementById('shippingProgress');
const addonsSection = document.getElementById('cartAddonsSection');

let activeCartCurrency = 'USD'; // Fallback currency
let currentCartState = null; // Stores the cart globally to read the split line "Keys"


// --- SPINNER LOGIC ---
function showCartSpinner() {
  const overlay = document.getElementById('cartActionOverlay');
  if (overlay) overlay.classList.add('is-loading');
}

function hideCartSpinner() {
  const overlay = document.getElementById('cartActionOverlay');
  if (overlay) overlay.classList.remove('is-loading');
}

function openCartDrawer() {
  // Disarm any pending Bundler interceptor: if the cart drawer
  // is already open, it makes no sense to keep blocking /checkout clicks.
  if (window.__bundlerInterceptDisarm) window.__bundlerInterceptDisarm();

  cartDrawer.classList.add('is-active');
  cartOverlay.classList.add('is-active');
  document.body.style.overflow = 'hidden';
  fetchCartData();
}

function closeCartDrawer() {
  cartDrawer.classList.remove('is-active');
  cartOverlay.classList.remove('is-active');
  document.body.style.overflow = '';
}

// Checkout click feedback — capture-phase listener so it runs BEFORE any
// external app listeners (LimeSpot, etc.) that attach to the button. Some
// apps inject lb-upsell-listener / lb-checkout-listener attributes and block
// our visual feedback.
//
// Capture phase = our listener runs FIRST, regardless of script init order.
// This guarantees the spinner appears instantly even if other listeners
// call stopPropagation.
document.addEventListener('click', function (e) {
  var btn = e.target && e.target.closest ? e.target.closest('#cartCheckoutBtn') : null;
  if (!btn) return;

  // Avoid double-click: if already loading, ignore further clicks.
  if (btn.classList.contains('is-loading')) {
    e.preventDefault();
    return;
  }

  // 1. Button loading state (class + text)
  btn.classList.add('is-loading');
  var textEl = btn.querySelector('.btn-checkout-text');
  if (textEl) {
    textEl.dataset.original = textEl.textContent;
    textEl.textContent = 'Loading...';
  }

  // 2. General overlay spinner
  if (typeof showCartSpinner === 'function') showCartSpinner();

  // 3. Safety net: if navigation fails, restore after 8s.
  setTimeout(function () {
    btn.classList.remove('is-loading');
    if (textEl && textEl.dataset.original) textEl.textContent = textEl.dataset.original;
    if (typeof hideCartSpinner === 'function') hideCartSpinner();
  }, 8000);

  // 4. Do NOT call preventDefault: let the browser perform the normal
  // navigation to /checkout (and let other listeners do their tracking).
}, true); // <-- TRUE = capture phase (key to the fix)

// (Kept on window in case some external site still calls it; the listener
// above is what actually handles things now.)
window.handleCheckoutClick = function (e) {
  // No-op: the delegated capture listener already handled this.
  // If for some reason the delegated listener did not attach (rare),
  // this fallback fires the same visual effects.
  var btn = document.getElementById('cartCheckoutBtn');
  if (!btn || btn.classList.contains('is-loading')) return;
  btn.classList.add('is-loading');
  var textEl = btn.querySelector('.btn-checkout-text');
  if (textEl) {
    textEl.dataset.original = textEl.textContent;
    textEl.textContent = 'Loading...';
  }
  if (typeof showCartSpinner === 'function') showCartSpinner();
};

// Add main product to cart. Reads the qty from the sticky bar selector
// when present; falls back to 1 otherwise. After a successful add, resets
// the input AND the sticky price back to 1 so the next purchase does not
// inherit the qty state.
function addMainItemToCart() {
  const variantId = document.getElementById('current-variant-id').value;
  const qtyInput = document.getElementById('stickyQtyInput');
  const qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
  openCartDrawer();
  showCartSpinner();
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 'items': [{ 'id': parseInt(variantId), 'quantity': qty }] })
  })
  .then(r => r.json())
  .then(() => {
    if (qtyInput) {
      qtyInput.value = 1;
      if (typeof updateStickyPriceForQty === 'function') updateStickyPriceForQty(1);
    }
    fetchCartData();
  })
  .catch(err => { console.error('Error adding to cart:', err); hideCartSpinner(); });
}

function addUpsellToCart(variantId, btnEl) {
  showCartSpinner();
  var upsellDiscountCode = (window.PDP_CONFIG && window.PDP_CONFIG.upsellsDiscountCode) || '';
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 'items': [{ 'id': variantId, 'quantity': 1 }] })
  })
  .then(r => r.json())
  .then(() => upsellDiscountCode ? fetch('/discount/' + encodeURIComponent(upsellDiscountCode)) : Promise.resolve())
  .then(() => new Promise(res => setTimeout(res, 250)))   // <-- wait for Bundler
  .then(() => {
    if (btnEl) { btnEl.classList.add('added'); btnEl.textContent = '✓ Added'; }
    fetchCartData();
  })
  .catch(err => { console.error('Error adding upsell:', err); hideCartSpinner(); });
}


// Fetch updated cart data
function fetchCartData() {
  fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(cart => {
    currentCartState = cart;
    activeCartCurrency = cart.currency || 'USD';
    hideCartSpinner();
    renderCartItems(cart);
    updateShippingBar(cart.total_price);
  })
  .catch(error => {
    console.error('Error fetching cart:', error);
    hideCartSpinner();
  });
}

function renderCartItems(cart) {
  cartItemsList.innerHTML = '';

  if (cart.item_count === 0) {
    cartEmptyMsg.style.display = 'block';
    cartItemsList.style.display = 'none';
    if (addonsSection) addonsSection.style.display = 'none';
    const cartFooter = document.querySelector('.cart-drawer-footer');
    if (cartFooter) cartFooter.style.display = 'none';
    if (shippingText && shippingProgress) {
      shippingText.innerHTML = `You're <strong>${formatMoney(FREE_SHIPPING_THRESHOLD * 100)}</strong> away from free shipping!`;
      shippingProgress.style.width = '0%';
      shippingProgress.style.background = '#000';
    }
    return;
  }

  cartEmptyMsg.style.display = 'none';
  cartItemsList.style.display = 'flex';
  const cartFooter = document.querySelector('.cart-drawer-footer');
  if (cartFooter) cartFooter.style.display = 'block';

  let qualifiesForBundle = cart.items.some(item =>
    item.product_title.includes('Raised Garden') ||
    item.product_title.includes('Planter Box') ||
    item.product_title.includes('Select Grade') ||
    item.product_title.includes('Garden Grade')
  );
  if (addonsSection) addonsSection.style.display = qualifiesForBundle ? 'block' : 'none';

  // --- GROUP SPLIT LINES BY VARIANT ---
  // Bundler often splits one variant into multiple lines (some discounted,
  // some not). We collapse them so the customer sees ONE row per variant,
  // summing BOTH original and final line prices.
  let groupedItemsMap = {};
  cart.items.forEach(item => {
    let key = item.variant_id;
    const itemOriginal = (typeof item.original_line_price === 'number') ? item.original_line_price : item.line_price;
    const itemFinal    = (typeof item.final_line_price    === 'number') ? item.final_line_price    : item.line_price;

    if (groupedItemsMap[key]) {
      groupedItemsMap[key].quantity += item.quantity;
      groupedItemsMap[key]._originalLinePrice += itemOriginal;
      groupedItemsMap[key]._finalLinePrice    += itemFinal;
    } else {
      groupedItemsMap[key] = Object.assign({}, item, {
        _originalLinePrice: itemOriginal,
        _finalLinePrice:    itemFinal
      });
    }
  });

  let groupedItems = Object.values(groupedItemsMap);

  groupedItems.forEach(item => {
    const hasLineDiscount = item._finalLinePrice < item._originalLinePrice;
    const savings = item._originalLinePrice - item._finalLinePrice;
    const savingsPct = item._originalLinePrice > 0
      ? Math.round((savings * 100) / item._originalLinePrice)
      : 0;

    const priceBlock = hasLineDiscount
      ? `<div class="cart-item-price-row">
          <span class="cart-item-price-strike">${formatMoney(item._originalLinePrice)}</span>
          <span class="cart-item-price cart-item-price-sale">${formatMoney(item._finalLinePrice)}</span>
          <span class="cart-item-savings-badge">−${savingsPct}%</span>
        </div>`
:   `<div class="cart-item-price">${formatMoney(item._finalLinePrice)}</div>`;

    const variantTitle = (item.variant_title && item.variant_title !== 'Default Title')
      ? item.variant_title
      : '';
    const variantLine = variantTitle
      ? `<div class="cart-item-variant">${variantTitle}</div>`
      : '';

    const itemHtml = `
      <div class="cart-item">
        <div class="cart-item-img"><img src="${item.image}" alt="${item.title}"></div>
        <div class="cart-item-details">
        <div class="cart-item-title">${item.product_title}</div>
          ${variantLine}
          ${priceBlock}
          <div class="cart-item-actions">
            <div class="qty-box">
              <button class="qty-btn" onclick="changeItemQuantity(${item.variant_id}, ${item.quantity - 1})">-</button>
              <input type="number" class="qty-input" value="${item.quantity}" readonly>
              <button class="qty-btn" onclick="changeItemQuantity(${item.variant_id}, ${item.quantity + 1})">+</button>
            </div>
            <button class="cart-item-remove" onclick="changeItemQuantity(${item.variant_id}, 0)">Remove</button>
          </div>
        </div>
      </div>`;
    cartItemsList.insertAdjacentHTML('beforeend', itemHtml);
  });

  // --- SUMMARY: ONE source of truth ---
  // cartValue - totalDiscount = subtotal, ALWAYS.
  // Using original_total_price - total_price is the universal truth that
  // covers cart-level discounts, line-level discounts, and Bundler's
  // line-splitting strategy.
  const cartValue     = cart.original_total_price;
  const subtotal      = cart.total_price;
  const totalDiscount = Math.max(0, cartValue - subtotal);

  const originalValueRow  = document.getElementById('cartDrawerOriginalValueRow');
  const discountRow       = document.getElementById('cartDrawerDiscountRow');
  const discountContainer = document.getElementById('cartDrawerDiscount');
  const originalValObj    = document.getElementById('cartDrawerOriginalValue');
  const totalObj          = document.getElementById('cartDrawerTotal');

  if (totalDiscount > 0) {
    if (originalValObj)   originalValObj.innerText = formatMoney(cartValue);
    if (originalValueRow) originalValueRow.style.display = 'flex';

    // Discount label resolution:
    //   1. Try to use the actual name(s) Shopify reports in
    //      cart.cart_level_discount_applications (e.g. "Black Friday Sale").
    //   2. Fall back to a neutral "Discount" label when Shopify does not
    //      surface a title (common with manual discount codes vs Automatic
    //      Discounts with a configured title).
    // Previously the fallback was hardcoded to "Buy More Save More", which
    // referenced a specific campaign that has since ended. The new generic
    // fallback works for every kind of discount.
    let discountLabel = 'Discount';
    if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
      const names = cart.cart_level_discount_applications.map(d => d.title).filter(Boolean);
      if (names.length) discountLabel = names.join(' + ');
    }
    if (discountRow) {
      const labelEl = discountRow.querySelector('span:first-child');
      if (labelEl) labelEl.textContent = discountLabel;
      discountRow.style.display = 'flex';
    }
    if (discountContainer) {
      discountContainer.innerHTML = `<span style="color:#d32f2f;">−${formatMoney(totalDiscount)}</span>`;
    }
  } else {
    if (originalValueRow) originalValueRow.style.display = 'none';
    if (discountRow)      discountRow.style.display = 'none';
  }

  if (totalObj) totalObj.innerText = formatMoney(subtotal);
}

function changeItemQuantity(variantId, targetQty) {
  if (!currentCartState) return;
  showCartSpinner();

  let itemsOfVariant = currentCartState.items.filter(i => i.variant_id == variantId);
  let currentTotal = itemsOfVariant.reduce((sum, i) => sum + i.quantity, 0);
  let diff = targetQty - currentTotal;
  let updates = {};

  if (targetQty <= 0) {
    itemsOfVariant.forEach(i => { updates[i.key] = 0; });
  } else if (diff > 0) {
    updates[itemsOfVariant[0].key] = itemsOfVariant[0].quantity + diff;
  } else if (diff < 0) {
    let rem = Math.abs(diff);
    for (let i = itemsOfVariant.length - 1; i >= 0; i--) {
      let it = itemsOfVariant[i];
      if (rem > 0) {
        if (it.quantity > rem) { updates[it.key] = it.quantity - rem; rem = 0; }
        else { updates[it.key] = 0; rem -= it.quantity; }
      }
    }
  }

  if (Object.keys(updates).length === 0) { hideCartSpinner(); return; }

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: updates })
  })
  .then(r => r.json())
  .then(() => fetchCartData())
  .catch(err => { console.error('Error updating quantity:', err); hideCartSpinner(); });
}
// Update shipping progress bar
function updateShippingBar(totalPriceCents) {
  const currentTotal = totalPriceCents / 100;
  const amountLeft = FREE_SHIPPING_THRESHOLD - currentTotal;

  if (amountLeft <= 0) {
    shippingText.innerHTML = `You've got <strong>FREE SHIPPING!</strong>`;
    shippingProgress.style.width = '100%';
    shippingProgress.style.background = '#4CAF50';
  } else {
    // Keep the original currency for global context ("US$50.00 away")
    const formatterFull = new Intl.NumberFormat('en-US', { style: 'currency', currency: activeCartCurrency });
    shippingText.innerHTML = `You're <strong>${formatterFull.format(amountLeft)}</strong> away from free shipping!`;
    const percentage = (currentTotal / FREE_SHIPPING_THRESHOLD) * 100;
    shippingProgress.style.width = `${percentage}%`;
    shippingProgress.style.background = '#000';
  }
}

// HARDENED MATH FORMATTER (Pure numbers and the $ symbol only)
function formatMoney(cents) {
  let str = (cents / 100).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
  if (str.endsWith('.00')) str = str.slice(0, -3);
  return '$' + str;
}

// Open/Close logic for the Compare Drawer
const compareDrawer = document.getElementById('compareDrawer');
const compareOverlay = document.getElementById('compareOverlay');

/* ============================================================
   COMPARE DRAWER — open with a specific mode
   ------------------------------------------------------------
   mode: 'styles' | 'depths' | 'widths'
     - styles: same depth + width, varies by edition (grade)
     - depths: same edition + width, varies by depth
     - widths: same edition + depth, varies by width

   The pivot is the CURRENT product's card (data-current="true").
   We compare every other card against the pivot and keep only
   the ones that match the "same dimensions" axis for the mode.
   Result: 2 cards visible (the pivot + the sibling that varies
   on the requested axis).
   ============================================================ */
function openCompareDrawer(mode) {
  mode = mode || 'styles';   // default keeps the old link working

  // Pull the comparison table into the modal wherever it currently lives.
  var compareTarget = document.getElementById('compare-drawer-target-v2');
  var compareTable = document.querySelector('.dctgd-container');
  if (compareTarget && compareTable && compareTable.parentNode !== compareTarget) {
    compareTarget.innerHTML = '';
    compareTarget.appendChild(compareTable);
  }

  // Update the drawer title to match the chosen mode.
  var titleEl = document.querySelector('.compare-drawer .cart-drawer-title');
  if (titleEl) {
    var titles = {
      styles: 'Compare Styles',
      depths: 'Compare Depths',
      widths: 'Compare Widths'
    };
    titleEl.textContent = titles[mode] || 'Compare';
  }

  // Filter cards for the chosen mode.
  filterCompareCards(mode);

  if (compareDrawer) compareDrawer.classList.add('is-active');
  if (compareOverlay) compareOverlay.classList.add('is-active');
  document.body.style.overflow = 'hidden';

  // Re-run row alignment after the modal renders.
  window.dispatchEvent(new Event('resize'));
  setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 200);
  setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 600);
}

function filterCompareCards(mode) {
  var grid = document.querySelector('.dctgd-grid');
  if (!grid) return;

  var cards = grid.querySelectorAll('.dctgd-card');
  if (!cards.length) return;

  // Find the pivot (current product's card).
  var pivot = null;
  for (var i = 0; i < cards.length; i++) {
    if (cards[i].getAttribute('data-current') === 'true') {
      pivot = cards[i];
      break;
    }
  }
  if (!pivot) pivot = cards[0];

  var pivotEdition = pivot.getAttribute('data-edition');
  var pivotDepth = pivot.getAttribute('data-depth');
  var pivotWidth = pivot.getAttribute('data-width');

  // For each card, decide if it stays visible based on the mode.
  // Pivot is ALWAYS visible. Other cards visible only if they
  // match the pivot on the 2 fixed dimensions and differ on the
  // varying one.
  cards.forEach(function (card) {
    if (card === pivot) {
      card.style.display = '';
      return;
    }
    var ed = card.getAttribute('data-edition');
    var de = card.getAttribute('data-depth');
    var wi = card.getAttribute('data-width');

    var keep = false;
    if (mode === 'styles') {
      keep = (de === pivotDepth) && (wi === pivotWidth) && (ed !== pivotEdition);
    } else if (mode === 'depths') {
      keep = (ed === pivotEdition) && (wi === pivotWidth) && (de !== pivotDepth);
    } else if (mode === 'widths') {
      keep = (ed === pivotEdition) && (de === pivotDepth) && (wi !== pivotWidth);
    }

    card.style.display = keep ? '' : 'none';
  });
}

function closeCompareDrawer() {
  if (compareDrawer) compareDrawer.classList.remove('is-active');
  if (compareOverlay) compareOverlay.classList.remove('is-active');
  document.body.style.overflow = '';
}

// Delegated handler for the comparison table "Shop now" buttons.
// Lives here (in the PDP script, which is known to run) so it works even
// when optimizer apps alter the comparison section's own inline script.
document.addEventListener('click', function (e) {
  var shopBtn = e.target.closest ? e.target.closest('.dctgd-btn[data-vid]') : null;
  if (!shopBtn) return;
  e.preventDefault();
  var vid = shopBtn.getAttribute('data-vid');
  if (!vid) return;
  if (shopBtn.classList.contains('loading')) return; // guard against double clicks
  shopBtn.classList.add('loading');

  fetch((window.Shopify ? window.Shopify.routes.root : '/') + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
  })
  .then(function (res) {
    shopBtn.classList.remove('loading');
    if (!res.ok) {
      res.text().then(function (t) { console.error('dctgd cart/add failed', res.status, t); });
      return;
    }
    closeCompareDrawer(); // close the compare modal
    openCartDrawer();     // open the PDP cart drawer (also refreshes contents)
  })
  .catch(function (err) {
    shopBtn.classList.remove('loading');
    console.error('dctgd cart add error', err);
  });
});

// Close with Escape key (cart + compare)
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closeCompareDrawer();
    closeCartDrawer();
  }
});

// Shop Pay Empty Space Fixer
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.querySelectorAll('.shopify-payment-terms').forEach(el => {
      if (!el.innerHTML.trim() || el.offsetHeight < 10) {
        let mob = el.closest('.installments-mobile');
        let desk = el.closest('.installments-desktop');
        if (mob) mob.style.display = 'none';
        if (desk) desk.style.display = 'none';
      }
    });
  }, 1000);
});

// Override the theme's header cart icon: open our custom cart drawer instead.
// Uses event delegation in the capture phase so it fires before the theme's own
// click handlers (and stopPropagation prevents them from running).
document.addEventListener('click', function (e) {
  var cartTrigger = e.target.closest && e.target.closest(
    'a[href="/cart"], a[href^="/cart?"], ' +
    '.site-header__cart, .site-header__cart-toggle, ' +
    '.header__icon--cart, .cart-link, ' +
    '[data-action="open-cart"], [aria-controls="cart-drawer"], ' +
    '.js-drawer-open-cart'
  );
  if (!cartTrigger) return;
  // Allow Cmd/Ctrl/Middle click to still go to /cart in a new tab
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
  e.preventDefault();
  e.stopPropagation();
  if (typeof openCartDrawer === 'function') openCartDrawer();
}, true); // capture phase: beats theme listeners


/* ============================================================
   B. BUY MORE & SAVE MORE — custom widget (PDP + cart)
   The discount is applied by Bundler (backend). This is UI only.
   ============================================================ */

// --- Qualifying unit counter in the cart ---
function bundleQualifyingCount(cart) {
  if (!cart || !cart.items) return 0;
  var kws = (window.BUNDLE_KEYWORDS || '').split(',')
    .map(function (s) { return s.trim().toLowerCase(); })
    .filter(Boolean);
  var n = 0;
  cart.items.forEach(function (it) {
    var t = (it.product_title || '').toLowerCase();
    if (kws.some(function (k) { return t.indexOf(k) !== -1; })) n += it.quantity;
  });
  return n;
}

// --- State: achieved tier and next tier ---
function bundleState(count) {
  var tiers = (window.BUNDLE_TIERS || []).slice().sort(function (a, b) { return a.qty - b.qty; });
  var achieved = null, next = null;
  tiers.forEach(function (t) { if (count >= t.qty) achieved = t; });
  for (var i = 0; i < tiers.length; i++) { if (tiers[i].qty > count) { next = tiers[i]; break; } }
  return { tiers: tiers, achieved: achieved, next: next, count: count };
}

function bundleAddWord(count, remaining) {
  if (count <= 0) return 'Buy ' + remaining;
  return remaining === 1 ? 'Add 1 more' : 'Add ' + remaining + ' more';
}

// (No DOMContentLoaded hook needed here — the cart-progress widget was removed.
//  The PDP Bundler widget mounts itself via the .bundler-target-element node.)

/* ===========================================================
   CUSTOM TIER BUTTONS — informational only
   ===========================================================
   Tier cards are no longer interactive. They visually communicate
   the bundle discount tiers ("2+ items / 10% off") but the actual
   discount is applied at checkout by Shopify Automatic Discounts.
   The previous click-to-add-N-items behavior was removed because
   it conflicted with the customer's intent to pick their own qty. */


/* ============================================================
   C. ROBUST TOOLTIP — mounts at <body>, immune to ancestor overflow
   ============================================================ */
(function() {
  var tooltipEl = null;
  var activeBtn = null;

  function ensure() {
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.className = 'js-tooltip';
      tooltipEl.setAttribute('role', 'tooltip');
      document.body.appendChild(tooltipEl);
    }
    return tooltipEl;
  }

  function position(btn, el) {
    var rect = btn.getBoundingClientRect();
    var tip = el.getBoundingClientRect();
    var left = rect.left + (rect.width / 2) - (tip.width / 2);
    var top = rect.top - tip.height - 10;
    var above = true;
    if (top < 8) { top = rect.bottom + 10; above = false; }
    if (left < 8) left = 8;
    var maxL = window.innerWidth - tip.width - 8;
    if (left > maxL) left = maxL;
    el.style.left = left + 'px';
    el.style.top = top + 'px';
    el.classList.toggle('is-above', above);
    el.classList.toggle('is-below', !above);
  }

  function show(btn) {
    var text = btn.getAttribute('data-tooltip');
    if (!text) return;
    var el = ensure();
    el.textContent = text;
    el.classList.add('is-visible');
    activeBtn = btn;
    requestAnimationFrame(function() { position(btn, el); });
  }

  function hide() {
    if (tooltipEl) tooltipEl.classList.remove('is-visible');
    activeBtn = null;
  }

function bind(btn) {
    if (btn.dataset.tooltipBound === '1') return;
    btn.dataset.tooltipBound = '1';

    // Detect touch device (no hover support). On touch, the tooltip
    // is replaced by the visible info bubble in the depth selector,
    // so we skip binding any interaction handlers — the bubble shows
    // the info statically and the button navigates as a plain link.
    var isTouch = window.matchMedia && window.matchMedia('(hover: none)').matches;
    if (isTouch) return;

    // Desktop: hover the whole button to see the tooltip.
    btn.addEventListener('mouseenter', function() { show(btn); });
    btn.addEventListener('mouseleave', hide);
    btn.addEventListener('focus', function() { show(btn); });
    btn.addEventListener('blur', hide);

    var icon = btn.querySelector('.info-icon');
    if (icon) {
      icon.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (activeBtn === btn) {
          hide();
        } else {
          show(btn);
          setTimeout(function() { if (activeBtn === btn) hide(); }, 4000);
        }
      });
    }
  }

  // Dismiss the tooltip when tapping outside any tooltip-bearing button.
  document.addEventListener('click', function(e) {
    if (!activeBtn) return;
    if (e.target.closest && e.target.closest('.btn-option[data-tooltip]')) return;
    hide();
  }, true);

  function init() {
    document.querySelectorAll('.btn-option[data-tooltip]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('scroll', function() {
    if (activeBtn && tooltipEl && tooltipEl.classList.contains('is-visible')) position(activeBtn, tooltipEl);
  }, { passive: true });
  window.addEventListener('resize', function() {
    if (activeBtn && tooltipEl && tooltipEl.classList.contains('is-visible')) position(activeBtn, tooltipEl);
  });
})();

/* ============================================================
   D. STICKY BAR — quantity selector + live price update
   ============================================================
   Reads the unit price (cents) from data attributes on
   #sticky-main-price, multiplies by qty, and rewrites the visible
   price/compare in place. The currency suffix and SAVE % badge
   stay untouched because they live in sibling nodes.
   ============================================================ */
function updateStickyPriceForQty(qty) {
  var priceWrap = document.getElementById('sticky-main-price');
  if (!priceWrap) return;
  var unitPrice = parseInt(priceWrap.getAttribute('data-unit-price'), 10) || 0;
  var unitCompare = parseInt(priceWrap.getAttribute('data-unit-compare'), 10) || 0;

  var newPrice = unitPrice * qty;
  var newCompare = unitCompare * qty;

  var valueEl = priceWrap.querySelector('.sticky-price-value');
  if (valueEl) valueEl.textContent = formatMoney(newPrice);

  var compareEl = document.getElementById('sticky-compare-price');
  if (compareEl && unitCompare > 0) {
    compareEl.textContent = formatMoney(newCompare);
  }
}

(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest && e.target.closest('.sticky-qty-btn');
    if (!btn) return;
    e.preventDefault();
    var input = document.getElementById('stickyQtyInput');
    if (!input) return;
    var current = parseInt(input.value, 10) || 1;
    var action = btn.getAttribute('data-qty-action');
    if (action === 'inc') current += 1;
    else if (action === 'dec') current = Math.max(1, current - 1);
    input.value = current;
    updateStickyPriceForQty(current);
  });
})();

/* ============================================================
   F. MOVE DEPTH INFO BUBBLE INTO THE DEPTH HEADER (MOBILE)
   ============================================================
   The bubble used to render under the buttons row, which made
   it visually point at the LAST button (rightmost) regardless
   of which one was selected. Moving it into the .selector-header
   on mobile places it inline with the dynamic "Planting Depth N""
   label, so it reads as a description of the CURRENT selection.

   On desktop the bubble is hidden via CSS (display:none) so the
   move has no effect there. On viewport changes we restore the
   bubble to its original parent.
   ============================================================ */
(function initDepthBubbleMove() {
  var bubble = document.querySelector('.selector-group.depth-group .depth-info-bubble');
  var header = document.querySelector('.selector-group.depth-group .selector-header');
  if (!bubble || !header) return;

  var origParent = bubble.parentNode;
  var origNextSibling = bubble.nextSibling;

  function sync() {
    var isMobilePortrait = window.matchMedia('(max-width: 1024px) and (orientation: portrait)').matches;
    if (isMobilePortrait && bubble.parentNode !== header) {
      header.appendChild(bubble);
    } else if (!isMobilePortrait && bubble.parentNode === header) {
      if (origParent) origParent.insertBefore(bubble, origNextSibling);
    }
  }

  sync();
  var mq = window.matchMedia('(max-width: 1024px) and (orientation: portrait)');
  if (mq.addEventListener) {
    mq.addEventListener('change', sync);
  } else if (mq.addListener) {
    mq.addListener(sync);
  }
})();


/* ============================================================
   E. MERGE VALUE-PROPS TICKER INTO MOBILE STICKY REVIEWS BAR
   ============================================================
   On mobile, move the rotating .value-props ticker from its
   original spot inside .info-group-top into the empty left slot
   of .mobile-sticky-reviews. This keeps a single source of truth
   for the ticker markup (still rendered once by Liquid with the
   admin-configurable icons + copy) while letting both the social
   proof (stars) and the benefit copy share the same sticky strip.

   We remember the original parent + nextSibling so we can move
   the ticker BACK on viewport resize from mobile to desktop, where
   the ticker is meant to render as a vertical list inside
   .info-group-top instead.
   ============================================================ */
(function initMobileTickerMerge() {
  var ticker = document.querySelector('.info-group-top .value-props') ||
               document.querySelector('.value-props');
  var slot = document.getElementById('mobileStickyTickerSlot');
  if (!ticker || !slot) return;

  // Remember where the ticker originally lives so we can restore
  // it if the user resizes from mobile to desktop.
  var origParent = ticker.parentNode;
  var origNextSibling = ticker.nextSibling;

  function sync() {
    var isMobile = window.matchMedia('(max-width: 1024px)').matches;
    if (isMobile && ticker.parentNode !== slot) {
      slot.appendChild(ticker);
    } else if (!isMobile && ticker.parentNode === slot) {
      // Restore to original DOM position (CSS order:6 still applies
      // and puts it visually back where it belongs on desktop).
      if (origParent) origParent.insertBefore(ticker, origNextSibling);
    }
  }

// Initial run + react to breakpoint changes.
  sync();
  var mq = window.matchMedia('(max-width: 1024px)');
  if (mq.addEventListener) {
    mq.addEventListener('change', sync);
  } else if (mq.addListener) {
    // Safari < 14 fallback
    mq.addListener(sync);
  }
})();


/* ============================================================
   === BEGIN SCROLL RESTORATION ===============================
   ============================================================
   Preserve scroll position when the customer navigates between
   sibling products via the configurator (Length, Depth, Width,
   Style cards). Without this, clicking "36"" while looking at
   the FAQ section reloads the page at scroll 0 and the
   customer loses context.

   How it works:
     1. On click of any configurator link, save window.scrollY
        and a timestamp into sessionStorage.
     2. On the new page load, read sessionStorage. If the save
        is recent (<30s), scroll to that Y position and clear
        the key.
     3. Disable browser's default scroll restoration so we
        control it explicitly.

   The 30-second TTL ensures stale positions from previous
   browsing sessions don't apply if the customer comes back to
   a configurator page much later (e.g. via back button hours
   later).

   ROLLBACK: delete everything between the BEGIN and END
   markers. No other file changes needed.
   ============================================================ */
(function initPdpScrollRestoration() {
  var STORAGE_KEY = 'pdpScrollY';
  var TTL_MS = 30000;   // 30 seconds

  // Take control of scroll restoration from the browser.
  // Without this, Chrome/Firefox try to "restore" scroll on
  // back/forward navigation which fights our manual call.
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  // STEP 1: restore on page load if a recent save exists.
  function tryRestore() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      // Always clear after reading so a single navigation only
      // restores once. Subsequent reloads start fresh at top.
      sessionStorage.removeItem(STORAGE_KEY);

      if (!data || typeof data.y !== 'number') return;
      var ageMs = Date.now() - (data.timestamp || 0);
      if (ageMs > TTL_MS) return;

      // Defer the scroll until layout has settled. requestAnimationFrame
      // alone is sometimes too early because lazy images further down
      // can push content. Two rAFs + a small timeout give the page time
      // to render the gallery + selectors + tabs.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          window.scrollTo({ top: data.y, left: 0, behavior: 'instant' });
          // Final correction after images load (max ~400ms wait).
          setTimeout(function () {
            window.scrollTo({ top: data.y, left: 0, behavior: 'instant' });
          }, 400);
        });
      });
    } catch (e) {
      // sessionStorage disabled / bad JSON / quota — ignore silently.
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryRestore);
  } else {
    tryRestore();
  }

  // STEP 2: save scroll position whenever a configurator link is
  // clicked. Capture phase so we run BEFORE the browser begins
  // navigation. Selector catches Length, Depth, Width buttons and
  // Style cards — all of which are <a href="/products/...">.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var link = e.target.closest('a[href^="/products/"]');
    if (!link) return;

    // Only save for links inside the configurator. Avoids saving
    // when clicking unrelated /products/ links (related products,
    // breadcrumbs, etc.) where the customer is intentionally moving
    // somewhere different.
    var insideConfigurator = link.closest('.btn-group, .style-cards-grid, .selectors-row');
    if (!insideConfigurator) return;

    // Allow Cmd/Ctrl/Middle click (opens new tab — no save needed).
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        y: window.scrollY || window.pageYOffset || 0,
        timestamp: Date.now()
      }));
    } catch (err) {
      // Quota exceeded / private mode — ignore.
    }
  }, true);   // capture: runs before any navigation handlers
})();
/* ============================================================
   === BEGIN DEPTH INFO POPOVER ===============================
   ============================================================
   Mobile-only behavior. The .depth-info-bubble used to be
   always-visible on mobile under the buttons row. We replaced
   it with a tap-to-show popover triggered by the (i) icon
   inside each depth button. The bubble appears for 4 seconds
   then fades out automatically. Also closes if the user taps
   anywhere outside the bubble or the icon.

   Desktop is unaffected — the icon there still uses the
   js-tooltip system already in place.

   ROLLBACK: delete everything between the BEGIN and END
   markers. The CSS bubble will return to its previous
   always-visible behavior once the show/hide class is no
   longer toggled.
   ============================================================ */
(function initDepthInfoPopover() {
  var AUTO_HIDE_MS = 4000;
  var hideTimer = null;
  var isMobile = function () {
    return window.matchMedia('(max-width: 1024px)').matches;
  };

  function getBubble() {
    return document.querySelector('.depth-info-bubble');
  }

  function showBubble() {
    var bubble = getBubble();
    if (!bubble) return;
    bubble.classList.add('is-visible');
    // Reset the auto-hide timer on every show so consecutive
    // taps refresh the 4s window instead of stacking timers.
    if (hideTimer) clearTimeout(hideTimer);
    hideTimer = setTimeout(hideBubble, AUTO_HIDE_MS);
  }

  function hideBubble() {
    var bubble = getBubble();
    if (!bubble) return;
    bubble.classList.remove('is-visible');
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
  }

// Delegated click: the .depth-info-trigger button sits next
  // to the "PLANTING DEPTH" label and toggles the bubble.
  // We removed the per-button (i) icon from inside each depth
  // button — there's only ONE trigger per group now.
  document.addEventListener('click', function (e) {
    if (!isMobile()) return;
    if (!e.target || !e.target.closest) return;

    var trigger = e.target.closest('.depth-info-trigger');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      var bubble = getBubble();
      if (bubble && bubble.classList.contains('is-visible')) {
        hideBubble();
        trigger.setAttribute('aria-expanded', 'false');
      } else {
        showBubble();
        trigger.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    // Tap outside the trigger or the bubble closes the popover.
    var insideBubble = e.target.closest('.depth-info-bubble');
    if (!insideBubble) {
      hideBubble();
      var openTrigger = document.querySelector('.depth-info-trigger[aria-expanded="true"]');
      if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
    }
  }, true);

  // If the breakpoint flips to desktop, make sure the popover
  // is dismissed so it does not stay stuck visible.
  var mq = window.matchMedia('(max-width: 1024px)');
  function syncOnBreakpointChange() { if (!isMobile()) hideBubble(); }
  if (mq.addEventListener) {
    mq.addEventListener('change', syncOnBreakpointChange);
  } else if (mq.addListener) {
    mq.addListener(syncOnBreakpointChange);
  }
})();
/* ============================================================
   === END DEPTH INFO POPOVER =================================
   ============================================================ */

  /* ============================================================
   SHIP DATE TWINS UI — dimensions modal + ship date navigation
   ============================================================ */
(function () {
  /* ---- Dimensions modal: moves the REAL .selectors-row into the
     modal on open (all existing handlers keep working) and returns
     it to its hidden placeholder on close. ---- */
  var placeholder = document.getElementById('dimSelectorsPlaceholder');
  var modalRoot   = document.getElementById('dimModalRoot');
  var modalBody   = document.getElementById('dimModalBody');
  var openBtn     = document.getElementById('dimSummaryCard');

  if (placeholder && modalRoot && modalBody && openBtn) {
    var lastFocused = null;

    function openModal() {
      lastFocused = document.activeElement;
      var row = placeholder.querySelector('.selectors-row');
      if (row) modalBody.appendChild(row);
      modalRoot.setAttribute('aria-hidden', 'false');
      document.body.classList.add('dim-modal-open');
      var closeBtn = modalRoot.querySelector('.dim-modal-close');
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKey);
    }

    function closeModal() {
      var row = modalBody.querySelector('.selectors-row');
      if (row) placeholder.appendChild(row);
      modalRoot.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dim-modal-open');
      document.removeEventListener('keydown', onKey);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); closeModal(); }
    }

    openBtn.addEventListener('click', openModal);
    modalRoot.addEventListener('click', function (e) {
      if (e.target.closest('[data-dim-close]')) closeModal();
    });
  }

  /* ---- Ship date radios: instant visual feedback, then navigate
     to the selected twin's product page. ---- */
  var radios = document.querySelectorAll('.ship-date-options input[name="shipDate"]');
  radios.forEach(function (r) {
    r.addEventListener('change', function () {
      radios.forEach(function (other) {
        var label = other.closest('.ship-date-option');
        if (!label || label.classList.contains('is-disabled')) return;
        label.classList.toggle('is-selected', other.checked);
      });
      var url = r.getAttribute('data-url');
      if (url && url !== window.location.pathname) window.location.href = url;
    });
  });
})();